import { render, staticRenderFns } from "./PlgBankStatement.vue?vue&type=template&id=556408fa&"
import script from "./PlgBankStatement.vue?vue&type=script&lang=js&"
export * from "./PlgBankStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports